/* eslint-disable max-len */
import React, {
    FC, useState, useEffect, useCallback, useId, useMemo,
} from 'react';
import { tp } from 'app/utils/typograf';
import {
    useQuery, useFragment, gql,
    useReactiveVar,
} from '@apollo/client';
import { useCartMutationInBasket } from 'app/views/Basket/hooks';
import { Portal } from 'react-portal';
import DELVIERY_BASKET_QUERY from 'app/graphql/network/basket/deliveryBasketQuery';
import BASKET_QUERY from 'app/graphql/network/basket/basketQuery';

import { UIToggleSwitch } from 'app/components/ui';

import { isDesktop } from 'app/utils/resolution';
import { DialogStatic } from 'app/components/Dialog/BR1156/DialogStatic';
import { makePrimetiveSection } from 'app/views/Basket/BasketListArea';
import { isGlobalLoadingVar, selectedPeriodVar, subscriptionTypeVar } from 'app/apollo/reaction';
import { analyticService } from 'global/services';

// @ts-ignore
import { useEveryInHiddenPeriod } from 'app/containers/BasketResolver';
import { isDateInRange } from 'app/containers/contexts/filters.context/filters.context';
// @ts-ignore
import dishId5040 from './img/5040.jpg';
// @ts-ignore
import dishId4707 from './img/4707.jpg';
// @ts-ignore
import dishId5275 from './img/5275.jpg';
// @ts-ignore
import dishId5276 from './img/5276.jpg';
// @ts-ignore
import dishId5332 from './img/5332.jpg';
// @ts-ignore
import dishId5394 from './img/5394.jpg';
// @ts-ignore
import dishId5337 from './img/5337.jpg';
// @ts-ignore
import dishId5438 from './img/5438.jpg';
// @ts-ignore
import dishId5490 from './img/5490.jpg';
// @ts-ignore
import dishId5506 from './img/5506.jpg';

import css from './AdditionalDish.module.scss';

const additionalDishRecord = [
    // default
    // {
    //     id: '4815',
    //     title: 'Новинка',
    //     caption: 'от шеф-повара',
    //     name: 'Соус блючиз',
    //     weight: '200г',
    //     detailTitleFirstLine: 'Соус блючиз',
    //     detailTitleSecondLine: 'от шеф-повара',
    //     hasTwoLinesOnDesktop: false,
    //     descriptionsLines: [
    //         'из сыра горгонзола с голубой плесенью — полностью натуральный состав',
    //         'по вкусу — сливочный, с пикантными нотками, превращает даже самое простое блюдо в деликатес',
    //         'универсальный — идеально дополнит свежие овощи, гренки, запечённый картофель, курицу, стейк, рыбу',
    //     ],
    //     photoPath: null,
    //     excludedByDishId: null,
    // },
    // show by periods
    {
        id: '4813',
        title: 'Домашний соус',
        caption: 'от шеф-повара',
        name: 'итальянский песто',
        weight: '200г',
        detailTitleFirstLine: 'Домашний соус песто',
        detailTitleSecondLine: 'от шеф-повара',
        hasTwoLinesOnDesktop: true,
        descriptionsLines: [
            'универсальный: хорош и с пастой, и с курицей, и просто намазать на хлеб',
            'готовим сами — по рецепту шефа',
            'из натуральных ингредиентов',
            'родом из солнечной Италии — придаёт любому блюду изысканный вкус',
        ],
    },
    {
        id: '7',
        title: 'Прочувствовать лето',
        caption: 'Манговый смузи',
        name: 'на кокосовом',
        weight: '200мл',
        detailTitleFirstLine: 'Манговый смузи',
        detailTitleSecondLine: 'с кокосовым молоком',
        hasTwoLinesOnDesktop: false,
        descriptionsLines: [
            'окунитесь в лето с сочным сладким манго',
            'заряд витаминов в каждой бутылочке',
            'натуральный состав!',
        ],
        photoPath: null,
        periods: [
            '2026-08-10',
            '2026-08-17',
        ],
        excludedByDishId: null,
    },
    {
        id: '4707',
        title: 'Украшения на Хэллоуин',
        caption: 'Пауки, паутина, мыши — ',
        name: 'всё для атмосферы',
        weight: '',
        detailTitleFirstLine: 'Украшения',
        detailTitleSecondLine: 'на Хэллоуин',
        hasTwoLinesOnDesktop: false,
        descriptionsLines: [
            'Всё для декора: летучие мыши, паутина с пауками и глаза-наклейки',
            'Тыква и инструкция, чтобы сделать из неё фонарь Джека',
            'Свечки и спички, чтобы зажечь тыкву-фонарь',
            'А ещё специи, чтобы после Хэллоуина сделать из него суп и съесть!',
        ],
        photoPath: dishId4707,
        periods: [
            '2026-10-26',
        ],
        excludedByDishId: '4695',
    },
    {
        id: '3871',
        title: 'Кое-что из Хогвартса',
        caption: 'То самое',
        name: 'сливочное пиво',
        weight: '2 х 330мл',
        detailTitleFirstLine: 'Сливочное пиво',
        detailTitleSecondLine: 'от мадам Розмерты',
        hasTwoLinesOnDesktop: false,
        descriptionsLines: [
            'магический напиток из вселенной Гарри Поттера',
            'сливочно-карамельный вкус и пенка из сливок',
            'согревающий, пряный — идеально для уютных осенних вечеров',
            'безалкогольный — можно (и нужно!) детям',
        ],
        periods: [
            '2026-11-09',
        ],
    },
    {
        id: '1257',
        title: 'Рождественские кексы',
        caption: 'Испечь, чтобы настоялись',
        name: 'к празднику',
        weight: '3 х 500г',
        weightDesktop: '3шт. по 500г',
        detailTitleFirstLine: 'Кексы',
        detailTitleSecondLine: '«Рождественская история»',
        hasTwoLinesOnDesktop: false,
        hasSpecialLineForWeight: true,
        descriptionsLines: [
            'проверенный годами праздничный хит!',
            'наполнит дом рождественскими ароматами',
            'начните готовить сейчас, чтобы настоялись к Новому году (можно настаивать весь декабрь)',
            'много сухофруктов: изюм, чернослив, клюква, инжир',
        ],
        periods: [
            '2025-12-01',
        ],
    },
    {
        id: '2752',
        title: 'Новинка к Новому году',
        caption: 'Имбирное печенье',
        name: 'себе и в подарок',
        weight: '350 г',
        detailTitleFirstLine: 'Имбирное печенье в подарочной ',
        detailTitleSecondLine: 'банке',
        hasTwoLinesOnDesktop: true,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'приятно и дарить, и приготовить самим',
            'наполняет дом особым ароматом праздника и новогодних европейских ярмарок',
            'в банке — уже смешанные ингредиенты, осталось добавить масло и яйца из своих продуктов и печь (формочка тоже есть!)',
        ],
        periods: [
            '2025-12-08',
            '2025-12-15',
        ],
    },
    {
        id: '5154',
        title: 'Для уютного вечера',
        caption: 'Пряный какао',
        name: 'с маршмеллоу',
        weight: '615 г',
        detailTitleFirstLine: 'Пряный какао с маршмеллоу',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'чтобы укутаться в плед, смотреть старые фильмы и ложкой ловить зефирки',
            'в составе: итальянское какао и согревающие пряности',
            'можно сделать более плотную консистенцию, и получится — густой горячий шоколад',
        ],
        periods: [
            '2025-12-22',
        ],
    },
    {
        id: '5155',
        title: 'Зимний must-have',
        caption: 'Согревающий',
        name: 'ягодный глинтвейн',
        weight: '1 л',
        detailTitleFirstLine: 'Согревающий ягодный глинтвейн',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            '300 г натуральной брусники, свежие апельсины, мёд и согревающие специи',
            'и дома, и в термос с собой, чтобы согреться на прогулке',
            'наполняет дом особым ароматом праздника и рождественских ярмарок',
            'можно сделать версию для взрослых, заменив воду на красное или белое сухое',
        ],
        periods: [
            '2026-01-04',
            '2026-01-05',
        ],
    },

    {
        id: '5275',
        title: 'Чтобы согреться',
        caption: 'Смесь пряностей',
        name: 'для глинтвейна',
        weight: '22 г',
        detailTitleFirstLine: 'Смесь пряностей для глинтвейна',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'чтобы провести последние холодные дни с согревающим зимним напитком!',
            'в составе только цельные пряности: палочки корицы, звёздочки бадьяна, гвоздика, кардамон зелёный, перец душистый целый',
            'в наборе есть рецепт: можно приготовить на красном сухом, а можно — безалкогольную версию на морсе, чае или ягодах',
            '1 пакетик рассчитан на 600 мл',
        ],
        periods: [
            '2026-02-16',
        ],
        photoPath: dishId5275,
    },
    {
        id: '5312',
        title: 'В подарок близким',
        caption: 'набор пирожных',
        name: 'макарон',
        weight: '9 шт',
        detailTitleFirstLine: 'Подарочный набор макарон',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'готовый десерт с хрустящими половинками и прослойкой нежнейшего крема',
            'изготовлены вручную из натуральных ингредиентов',
            '3 вкуса в наборе: солёная карамель, фисташка на белом шоколаде и молочный бельгийский шоколад',
            '9 штук в подарочной коробке, чтобы порадовать близких или себя',
        ],
        periods: [
            '2026-03-02',
        ],
    },
    {
        id: '3386',
        title: 'Закуска-деликатес',
        caption: 'Итальянское',
        name: 'прошутто',
        weight: '100 г',
        detailTitleFirstLine: 'Прошутто',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'изготовлено по правильному итальянскому рецепту',
            'тающие ломтики с благородным вкусом',
            'деликатес, который можно есть и как отдельную закуску, и как дополнение к блюдам',
        ],
        periods: [
            '2026-03-09',
            '2026-03-16',
            '2026-03-23',
        ],
    },
    {
        id: '172',
        title: 'К завтраку или на закуску',
        caption: 'Нежнейшее',
        name: 'патте из индейки',
        weight: '220 г',
        detailTitleFirstLine: 'Патте из индейки',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'нежнейший, тающий во рту паштет с шёлковой текстурой — в паре с багетом исчезает за раз',
            'в основе — печень индейки с добавлением ароматных яблок поздних сортов',
            'приготовлен нашими поварами на производстве',
            'привозим в красивой стекляной баночке',
            'идеален — и на завтрак, и на обед, и просто как самостоятельная закуска',
        ],
        periods: [
            '2026-09-07',
            '2026-09-14',
        ],
    },
    {
        id: '5332',
        title: 'Десерт украшение',
        caption: 'Драже Праздничный',
        name: 'миндаль',
        weight: '60 г',
        detailTitleFirstLine: 'Драже «Праздничный» миндаль',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'полезная сладость из цельного миндаля в молочном шоколаде и в глазури: йогуртовой и шоколадной',
            'в праздничных цветах: золото, жемчуг, акварель — чтобы сделать пасхальный стол ещё ярче',
        ],
        periods: [
            '2026-04-06',
        ],
        photoPath: dishId5332,
    },

    {
        id: '5394',
        title: 'Фермерские чикен-стейки',
        caption: '',
        name: 'в лимонном маринаде',
        weight: '700 г',
        detailTitleFirstLine: 'Лимонные чикен-стейки',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'из натуральной фермерской курицы',
            'в сочном лимонном маринаде от нашего шефа',
            'универсальны в приготовлении: можно и на огне, и в тандыре, и дома — на сковороде или в духовке',
            'сочетается с любым гарниром и овощами',
        ],
        periods: [
            '2026-09-21',
        ],
        photoPath: dishId5394,
    },

    {
        id: '5337',
        title: 'Куриная грудка су-вид',
        caption: 'сочная и мягкая',
        name: 'Уже готово!',
        weight: '160 г',
        detailTitleFirstLine: 'Куриная грудка су-вид',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'натуральная куриная грудка — белок и ничего лишнего',
            'уже готово!',
            'сохраняет идеальную сочность, нежность и полезные вещества, благодаря технологии медленного приготовления (су-вид)',
            'можно сочетать с салатами или гарнирами, а можно — как самостоятельную закуску',
        ],
        periods: [
            '2026-05-11',
        ],
        photoPath: dishId5337,
    },

    {
        id: '5438',
        title: 'Корзина ягод от фермеров:',
        caption: '',
        name: 'клубника и черешня',
        weight: '450г',
        detailTitleFirstLine: 'Корзина ягод от фермеров:',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            '200 грамм клубники и 250 грамм черешни',
            'закупаем напрямую у фермеров',
            'как с летнего рынка – только в доставке!',
        ],
        periods: [
            '2026-06-15',
            '2026-06-22',
            '2026-06-29',
        ],
        photoPath: dishId5438,
    },

    {
        id: '5468',
        title: 'Медовые абрикосы',
        caption: '',
        name: 'Шалах из Армении',
        weight: '300г',
        detailTitleFirstLine: 'Медовые абрикосы',
        detailTitleSecondLine: 'Шалах из Армении',
        hasTwoLinesOnDesktop: true,
        hasTwoLinesOnMobile: true,
        descriptionsLines: [
            'лучшие абрикосы сезона — медовая сладость, сочная мякоть и насыщенный аромат',
            'отбираем только самые спелые и сладкие плоды',
            'без химической обработки',
            'бережная доставка — вместе с «Ешь деревенское»',
        ],
        periods: [
            '2026-07-06',
            '2026-07-13',
        ],
        // photoPath: dishId5438,
    },
    {
        id: '5490',
        title: 'Сезонная голубика',
        caption: '',
        name: 'спелая и сладкая',
        weight: '125г',
        detailTitleFirstLine: 'Сезонная голубика',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'спелая, сладкая',
            'вкусно есть просто так или добавить к йогурту, сырникам, в кашу',
            'без химической обработки',
            'бережная доставка — вместе с «Ешь деревенское»',
        ],
        periods: [
            '2026-07-27',
            '2026-08-03',
        ],
        photoPath: dishId5490,
    },
    {
        id: '5506',
        title: 'Сладость ко Дню учителя',
        caption: 'набор шоколадных',
        name: 'карандашей',
        weight: '6 шт.',
        detailTitleFirstLine: 'Набор шоколадных карандашей',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'маленький привет из детства для тех, кто уже вырос, и приятный сюрприз для тех, кто ходит в школу',
            'молочный и белый шоколад, белый с клубникой и с карамелью',
            'угостить одноклассников, подарить учителю или просто побаловать себя',
        ],
        periods: [
            '2026-09-28',
        ],
        photoPath: dishId5506,
    },
    {
        id: '4168',
        title: 'Английское печенье',
        caption: 'от Теда Лассо',
        name: 'к финалу сезона',
        weight: '400 г',
        detailTitleFirstLine: 'Печенье от Теда Лассо',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'к выходу последней серии 4 сезона (или просто к чаю)',
            'приготовьте то самое английское печенье, с которым Тед приходил мириться к Ребекке',
            'невероятно нежное, тает во рту — секретная сливочность, заставившая американца Теда послушно называть печенье «бисквитами»',
        ],
        periods: [
            '2026-10-05',
        ],
    },
    {
        id: '5040',
        title: 'Домашний соус',
        caption: 'от шеф-повара',
        name: 'солёная карамель',
        weight: '',
        detailTitleFirstLine: 'Солёная карамель от шеф-повара',
        detailTitleSecondLine: '',
        hasTwoLinesOnDesktop: false,
        hasTwoLinesOnMobile: false,
        descriptionsLines: [
            'полюбившийся вам топпинг — теперь отдельно!',
            'можно добавлять к завтраку, к кофе или просто есть ложками, как десерт',
            'полностью натуральный состав',
        ],
        periods: [
            '2026-10-12',
            '2026-10-19',
            '2026-10-26',
        ],
    },
    {
        id: '5556',
        title: 'Лимитированный напиток',
        caption: 'Готовый яблочный компот',
        name: ' с кизилом',
        weight: '500 мл',
        detailTitleFirstLine: 'Готовый яблочный',
        detailTitleSecondLine: 'компот с кизилом',
        hasTwoLinesOnDesktop: true,
        hasTwoLinesOnMobile: true,
        descriptionsLines: [
            'лимитированный осенний напиток!',
            'вкус наливных яблок из бабушкиного сада',
            'домашний рецепт, в составе только вода, яблоки, кизил, немного сахара и лимонный сок',
            'заряд витаминов в каждой бутылочке',
        ],
        periods: [
            '2026-11-02',
        ],
    },


    // {
    //     id: '5276',
    //     title: 'На десерт',
    //     caption: 'Пирожное брауни',
    //     name: 'уже готово',
    //     weight: '70 г',
    //     detailTitleFirstLine: 'Пирожное брауни',
    //     detailTitleSecondLine: '',
    //     hasTwoLinesOnDesktop: false,
    //     hasTwoLinesOnMobile: false,
    //     descriptionsLines: [
    //         'шоколадный десерт по фирменному рецепту шеф-повара',
    //         'из итальянского какао и сливочного масла',
    //         'нежнейший, тает во рту',
    //         'уже готов — можно сразу есть',
    //     ],
    //     periods: [
    //         '2026-02-23',
    //     ],
    //     photoPath: dishId5276,
    // },
];

// Пряный какао с маршмеллоу

const IS_DELIVERY_CART_ANABLED_FRAGMENT = gql`
fragment IS_DELIVERY_CART_ANABLED_FRAGMENT on delivery {
    id
    is_edit_enabled
}`;


export const AdditionalDish: FC = ({ hasRootClass = true }: any) => {
    const period = useReactiveVar(selectedPeriodVar);

    const searchParams = new URLSearchParams(window.location.search);
    const paymentMethod = searchParams.get('payment');
    const deliveryId = window.location.pathname.split('/').find((e) => Boolean(e) && !Number.isNaN(Number(e)));

    const CURRENT_BASKET_QUERY = deliveryId ? DELVIERY_BASKET_QUERY : BASKET_QUERY;

    const { isCartUpdating, mutateItemInCart } = useCartMutationInBasket({ delivery_Id: deliveryId || undefined });

    const [isDialogOpenned, setIsDialogOpenned] = useState<boolean>(false);
    const [isDesktopResolution, setIsDesktopResolution] = useState<boolean>(isDesktop());
    const labelId = useId();

    const isGlobalLoading = useReactiveVar(isGlobalLoadingVar);

    const { data: currentBasketData } = useQuery(
        CURRENT_BASKET_QUERY,
        {
            variables: {
                period: selectedPeriodVar(),
                deliveryId: deliveryId || undefined,
            },
        },
    );

    const { data: deliveryData } = useFragment({
        fragment: IS_DELIVERY_CART_ANABLED_FRAGMENT,
        from: {
            __ref: `delivery:${deliveryId}`,
        },
    }) || {};

    const primetiveSection = useMemo(
        () => makePrimetiveSection(currentBasketData?.cart?.sections),
        [currentBasketData],
    );

    const matchingAdditionalDishes = useMemo(
        () => additionalDishRecord.filter((e) => e.periods
            ?.some((p) => isDateInRange(p, period))),
        [period],
    );

    const excludingDish = useMemo(
        () => (matchingAdditionalDishes as any[]).find((e) => Boolean(e.excludedByDishId)) || null,
        [matchingAdditionalDishes],
    );

    const isExcludingDishInBasket = useMemo(
        () => {
            if (!excludingDish?.excludedByDishId) {
                return false;
            }
            const dishesInBasket = primetiveSection.map((dishWithType: string) => dishWithType.split(':')[1]);
            return dishesInBasket
                .some((dishId: any) => dishId === excludingDish.excludedByDishId);
        },
        [primetiveSection, excludingDish],
    );

    const additionalDishData = useMemo(
        () => {
            if (!matchingAdditionalDishes.length) {
                return additionalDishRecord[0];
            }

            if (excludingDish && matchingAdditionalDishes.length > 1) {
                return isExcludingDishInBasket
                    ? matchingAdditionalDishes.find((e) => e !== excludingDish) || excludingDish
                    : matchingAdditionalDishes[0];
            }

            return matchingAdditionalDishes[0];
        },
        [matchingAdditionalDishes, excludingDish, isExcludingDishInBasket],
    );

    const {
        id, title, caption, name, weight, descriptionsLines,
        detailTitleFirstLine, detailTitleSecondLine, hasTwoLinesOnDesktop, hasSpecialLineForWeight, photoPath,
        excludedByDishId,
        weightDesktop = null,
        hasTwoLinesOnMobile = true,
    } = additionalDishData;

    // const {
    //     data: { discount_price },
    // } = useFragment({
    //     fragment: gql`
    //      fragment NEW_DISH_CARD_FRAGMENT on cartItem {
    //         discount_price
    //     }`,
    //     from: {
    //         __ref: `cartItem:${id}`,
    //     },
    // });

    const { data } = useQuery(
        gql`
            query DISH_DATA(
                $id: ID!,
                $period: String!,
            ) {
                menuDish(id: $id, period: $period) {
                    id,
                    title,
                    caption,
                    price,
                    portions,
                    previewMobileImage,
                }
            }
        `,
        {
            variables: {
                id,
                period: selectedPeriodVar(),
            },
            fetchPolicy: 'cache-first',
        },
    ) || {};

    const hasAdditionalDishInBasket = useMemo(
        () => {
            const dishesInBasket = primetiveSection.map((dishWithType: string) => dishWithType.split(':')[1]);
            return dishesInBasket
                .some((dishId: any) => dishId === id);
        },
        [primetiveSection, id],
    );

    const hasExcludingDishInBasket = useMemo(
        () => {
            const dishesInBasket = primetiveSection.map((dishWithType: string) => dishWithType.split(':')[1]);
            return dishesInBasket
                .some((dishId: any) => dishId === excludedByDishId);
        },
        [primetiveSection, excludedByDishId],
    );

    const [isChecked, setIsChecked] = useState<boolean>(hasAdditionalDishInBasket);

    const portionsToAdd = useMemo(
        () => (
            Array.isArray(data?.menuDish?.portions)
                ? data?.menuDish?.portions[0]
                : 1
        ),
        [data],
    );

    const toggleAdditionalSwitch = useCallback(
        () => {
            if (hasAdditionalDishInBasket) {
                mutateItemInCart(
                    // @ts-ignore
                    {
                        dishes: [{
                            dish_id: id,
                            portions: 0,
                        }],
                    },
                );
                setIsChecked(false);
                return;
            }

            mutateItemInCart(
                // @ts-ignore
                {
                    dishes: [{
                        dish_id: id,
                        portions: portionsToAdd,
                    }],
                    onCompletedCallback: () => {
                        sessionStorage.setItem('additionalDishAdded', 'true');
                        analyticService.push({
                            eventName: 'add_to_cart',
                            dishes: [{ ...data?.menuDish, portion: portionsToAdd }],
                            source: 'upsell_check_mark',
                            subscriptionType: subscriptionTypeVar(),
                            typeOfSet: currentBasketData?.cart?.typeOfSet,
                        });
                    },
                });
        },
        [
            currentBasketData?.cart?.typeOfSet,
            id,
            hasAdditionalDishInBasket,
            data,
            portionsToAdd,
            mutateItemInCart,
        ],
    );

    const checkDesktopResolution = useCallback(
        () => setIsDesktopResolution(isDesktop()),
        [],
    );

    const onReject = () => {
        setIsDialogOpenned(false);
    };

    useEffect(
        () => {
            window.addEventListener(
                'resize',
                checkDesktopResolution,
            );
            return () => {
                window.removeEventListener('resize', checkDesktopResolution);
            };
        },
        [checkDesktopResolution],
    );

    useEffect(
        () => {
            setIsChecked(hasAdditionalDishInBasket);
        },
        [hasAdditionalDishInBasket],
    );

    const price = useMemo(() => {
        const dv = currentBasketData?.cart?.isSubscriptionActivated || paymentMethod === 'recurrent' ? 10 : 0;
        // eslint-disable-next-line no-unsafe-optional-chaining, no-mixed-operators
        const currentPrice = data?.menuDish?.price;
        const discount = (currentPrice / 100) * dv;
        // eslint-disable-next-line no-unsafe-optional-chaining
        return Math.floor((currentPrice - discount) * portionsToAdd);
    }, [data?.menuDish?.price, paymentMethod, currentBasketData, portionsToAdd]);

    const confirmText = useMemo(
        () => `Добавить за ${price} ₽`,
        [price],
    );

    const isEveryHidden = useEveryInHiddenPeriod();

    if (!deliveryData?.is_edit_enabled && deliveryId) {
        return null;
    }

    if (hasExcludingDishInBasket) {
        return null;
    }

    if (isEveryHidden) {
        return null;
    }

    return (
        <div className={hasRootClass ? css.additionalDishRowRoot : ''}>
            <div className={css.additionalDishRowFlexContainer}>
                <div className={css.additionalDishRowContent}>
                    <div
                        className={css.additionalDishRowContentText}
                        style={{ cursor: 'pointer' }}
                        role="none"
                        onClick={() => {
                            analyticService.push({
                                eventName: 'Click_open_popup_upsell_check_mark',
                                dish_id: id,
                                dish_name: data?.menuDish?.title,
                            });
                            setIsDialogOpenned(true);
                        }}
                    >
                        <div className={css.bold}>{title}</div>
                        {caption && (
                            <>
                                {caption}
                                <br />
                            </>
                        )}
                        <div className={css.additionalDishRowContentText}>
                            <span
                                className={css.additionalDishRowTextDecoration}
                            >
                                {name}
                                {' '}
                                <span
                                    className={css.additionalDishRowDigitsDecoration}
                                >
                                    {weight}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className={css.additionalDishRowToggleWrapper}>
                    <div className={css.additionalDishPriceRow}>
                        +
                        {price}
                        {' '}
                        ₽
                    </div>
                    <UIToggleSwitch
                        onChanegHandler={toggleAdditionalSwitch}
                        isChecked={isChecked}
                        id={labelId}
                        isDisabled={isCartUpdating || isGlobalLoading}
                    />
                </div>
                <Portal>
                    <DialogStatic
                        rejectText=""
                        confirmText={confirmText}
                        isOpen={isDialogOpenned}
                        onConfirm={() => {
                            toggleAdditionalSwitch();
                            setIsDialogOpenned(false);
                        }}
                        onReject={onReject}
                        textAlign="start"
                        isCloseConfirmAction={false}
                        // @ts-ignore
                        responisve={!isDesktopResolution}
                        isProfileLayout
                        isNewIrresponsiveLayout
                        oneRowButtons
                        buttonsReversed
                        onlyConfirmButton
                    >
                        <>
                            <div className={css.additionalDishModalTitle}>
                                {isDesktopResolution
                                    ? (
                                        <>
                                            {!hasTwoLinesOnDesktop && `${detailTitleFirstLine} ${detailTitleSecondLine}`}
                                            {hasTwoLinesOnDesktop && (
                                                <>
                                                    {detailTitleFirstLine}
                                                    <br />
                                                    {detailTitleSecondLine}
                                                </>
                                            )}
                                        </>
                                    )
                                    : (
                                        <>
                                            {detailTitleFirstLine}
                                            {hasTwoLinesOnMobile && <br />}
                                            {detailTitleSecondLine}
                                        </>
                                    )}
                                {' '}
                                {hasSpecialLineForWeight && <br />}
                                <span className={css.additionalDishRowDigitsDecoration}>
                                    {
                                        isDesktopResolution
                                            ? weightDesktop || weight
                                            : weight
                                    }
                                </span>
                                {' '}
                            </div>
                            <img
                                className={css.additionalDishDialogImage}
                                src={photoPath || data?.menuDish?.previewMobileImage}
                                alt="dish"
                            />
                            <ul className={css.additionalDishModalList}>
                                {descriptionsLines.map((line: any) => (
                                    <li key={line.slice(0, 10)}>
                                        {tp.execute(line)}
                                    </li>
                                ))}
                            </ul>
                        </>
                    </DialogStatic>
                </Portal>
            </div>
        </div>
    );
};
